import styled, { css } from 'styled-components';
import { rem } from 'polished';
import Icon from '../Icon';

// Caja para el input
const StyledInputBox = styled.div`
  position: relative;
  width: ${props => (props.width ? props.width : '100%')};
`;

// Capa de Error
const BoxError = styled.div`
  top: 100%;
  position: absolute;
  right: ${rem('0px')};
  text-align: right;
`;

// Icono de error
const StyledIconError = styled(Icon)`
  cursor: default;
  fill: ${props => props.theme.colors.error};
`;

// Texto del error
const StyledError = styled.p`
  color: ${props => props.theme.colors.error};
  font-size: ${props => props.theme.fontSize.xsmall};
  line-height: 1rem;
  margin: 0;
  position: relative;
  top: 0;
  right: 0;
`;

// Input
const StyledInput = styled.input`
  line-height: 1.2;
  /* Estilos comunes Input y text Area */
  padding: ${rem('11px')} ${rem('18px')} ${rem('11px')} ${rem('8px')};
  width: 100%;
  font-family: ${props => props.theme.fonts.book};
  font-size: ${rem('14px')};
  border: ${rem('1px')} solid ${props => props.theme.colors.grayLight};
  &:focus {
    outline: none;
    border-color: ${props => props.theme.colors.secondary};
    font-family: ${props => props.theme.fonts.bold};
    font-weight: 700;
    &::placeholder {
      font-family: ${props => props.theme.fonts.book};
      font-weight: 400;
    }
  }
  ${props =>
    props.disabled &&
    css`
      background-color: ${props.theme.colors.grayLightest};
      border: 1px solid ${props.theme.colors.grayLight};
      color: ${props.theme.colors.gray};
      cursor: default;
    `};
  ${props =>
    (props.error || props.errorTitle) &&
    css`
      border: 2px solid ${props.theme.colors.error};
    `};

  &:-internal-autofill-selected {
    background-color: ${props => props.theme.colors.grayLightest};
  }

  /* FIN de estilos comunes*/
`;

// Text Area
const StyledTextArea = StyledInput.withComponent('textarea').extend`
  /* Usa los estilos comunes de StyledInput más este: */
  line-height: 1.2rem;
  width: 100%;
  max-width: 100%;
  ${props =>
    (props.error || props.errorTitle) &&
    css`
      border: 2px solid ${props.theme.colors.error};
    `};
`;

const StyledErrorTitle = styled.span`
  right: ${rem('3px')};
  position: absolute;
  top: ${rem('-28px')};
  display: block;
  width: ${rem('20px')};
  height: ${rem('20px')};
  cursor: help;
  svg {
    cursor: help;
  }
`;

export {
  StyledInputBox,
  StyledInput,
  StyledError,
  BoxError,
  StyledIconError,
  StyledTextArea,
  StyledErrorTitle
};
